var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._b({staticClass:"circular-status",style:(_vm.cor),attrs:{"square":_vm.square}},"span",_vm._d({},[_vm.size,true])))}
var staticRenderFns = []

export { render, staticRenderFns }